import React from "react";
import FrontendSkill from "./frontendskill";
import BackendSkill from "./backendskill";
import OtherSkills from "./otherskill";

const Skills = () => {
  return (
    <React.Fragment>
      <div className="container m-auto">
        <h3 className="fw-bold text-center">SKILLS</h3>
        <p className="text-center mt-2">
          Below is a quick overview of my main technical skill sets and tools I
          use.
        </p>
        <h6 className="fw-bold text-center">EDUCATION</h6>
        <p className="text-center mt-1">
          <b>B.E Computer Science and Engineering</b>
          <p className="text-center">
            (Valliammai Engineering College, Chennai.)
          </p>
        </p>
      </div>
      <div className="mx-auto pt-5 mt-5">
        <div className="row d-flex flex-wrap">
          <div className="col-12 col-lg-4 mb-5 mb-3 mb-lg-0">
            <FrontendSkill />
          </div>
          <div className="col-12 col-lg-4 mb-5 mb-3 mb-lg-0">
            <BackendSkill />
          </div>
          <div className="col-12 col-lg-4 mb-5 mb-3 mb-lg-0">
            <OtherSkills />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Skills;
